import {pluralize, React, observer, _, Fragment, Popover2} from '@api'
import {Popover} from '@blueprintjs/core'
import {toJS} from 'mobx'
import * as css from './BOMSpecUsages.css'
import {nav, useCatalog} from '@stores'
import {DataMapper, ListPreviewCard} from 'centric-ui-components'
import {IBomRollupUsage, useBillOfMaterialsSpecRowStore, BOMRollups, GlobalSpecBOMRollups} from './'

export const BOMSpecUsages= observer(() => {
  const {rollupByCatalogItem} = useBillOfMaterialsSpecRowStore(),
    {catalogItemName} = useCatalog()

  return _.isEmpty(rollupByCatalogItem) ? null : (
    <Popover2
      className={css.usedByPopover}
      lazy
      position='right'
      interactionKind='click'
      content={<BomSpecUsagesPopoverContent/>}
      popoverClassName={css.popover}
      minimal={false}
    >
      <div className={css.summaryLabel}>Used by {rollupByCatalogItem.length} other {pluralize(catalogItemName, rollupByCatalogItem.length)}</div>
    </Popover2>
  )
})

const BomSpecUsagesPopoverContent = observer(function BomSpecUsagesPopoverContent() {
  const {rollupByCatalogItem} = useBillOfMaterialsSpecRowStore(),
    {catalogItemName} = useCatalog()

  return _.isEmpty(rollupByCatalogItem) ? null : (
    <div className={css.useByPopoverContent}>
      <div className={css.grid} style={{'--rows': rollupByCatalogItem?.length ?? 0} as any}>
        <div className={css.itemColumnHeader}>{catalogItemName}</div>
        <div className={css.bomColumnHeader}>Totals</div>

        {rollupByCatalogItem.map((rollupUsage, i) => <CatalogItemBomUsageSummary key={i} index={i} rollupUsage={rollupUsage}/>)}

        <div className={css.bomTotalsCell}>
          <GlobalSpecBOMRollups />
        </div>
      </div>
    </div>
  )
})

const CatalogItemBomUsageSummary = observer<{ rollupUsage: IBomRollupUsage, index: number }>(function CatalogItemBomUsageSummary({index, rollupUsage: {_id, _source, rollups}}) {
  const {workspaceConfig, dataMap, sidebar, stores} = useCatalog()

  return <Fragment>
    <div style={{gridRow: index + 2}} className={css.catalogItemCell}>
      <a href={
        nav.urlFor_string({
          workspace: workspaceConfig,
          // queryParams: {
          //   ...sidebar.queryParamsFor({
          //     right: {
          //       open: true,
          //       path: [
          //         {where: [{value: _id}]}
          //       ]
          //     }
          //   })
          // }
        })
      } target='_blank'>
        <DataMapper data={_source} config={dataMap}>
          <ListPreviewCard stores={stores} showImage className={css.previewCard} hideTooltips/>
        </DataMapper>
      </a>
    </div>

    <div style={{gridRow: index + 2}} className={css.bomCell}>
      <BOMRollups rollupResults={rollups} includeSpecQuantity/>
    </div>
  </Fragment>
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/BillOfMaterials/BOMSpecUsages.tsx